import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const DoublePurchaseModuleContextExtension = ModuleExtensions.contextExtension({});
//# sourceMappingURL=context.extension.js.map